import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const PropertyMarket: FC<RouteComponentProps> = (props) => {
  let renewalProbabilityRoute = toggles.displayNewRenewalProbability() ? {name: 'Renewal Probability', link: "/n/property-market/renewal-probability"} : {name: 'Renewal Probability', link: "/property-market/renewal-probability", hard: true}
  let downtimeRoute = toggles.displayNewDowntime() ? {name: 'Downtime', link: "/n/property-market/downtime"} : {name: 'Downtime', link: "/property-market/downtime", hard: true}
  let inflationRoute = toggles.displayNewInflation() ? {name: 'Inflation', link: "/n/property-market/inflation"} : {name: 'Inflation', link: "/property-market/inflation", hard: true}
  let marketLeaseRoute = toggles.displayNewMarketLease() ? {name: 'Market Lease', link: '/n/property-market/market-lease'} : {name: 'Market Lease', link: "/property-market/market-lease", hard: true}

  let tabs: Route[] = [
    inflationRoute,
    marketLeaseRoute,
    renewalProbabilityRoute,
    downtimeRoute,
    {name: "Vacancy/Credit Loss", link: "/n/property-market/vacancy-credit-loss"}
  ]

  return (
    <Container_s>
      <Subnav section="PROPERTY MARKET" tabs={tabs}/>
      <Content_s>
        {props.children}
      </Content_s>
    </Container_s>
  )
}

export default PropertyMarket
